var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4724 1C21.7274 1 21.9834 1.0972 22.1794 1.2922L23.5934 2.7072C23.9834 3.0972 23.9834 3.7312 23.5934 4.1212L9.1284 18.5862C9.0584 18.6732 8.9174 18.7632 8.8204 18.8002L5.7074 19.8602C5.7074 19.8602 5.5974 19.8872 5.5414 19.8872C5.2424 19.8872 4.9994 19.6442 4.9994 19.3452C4.9994 19.3042 5.0154 19.2142 5.0154 19.2142L6.0844 16.0512C6.1164 15.9552 6.2794 15.7782 6.3004 15.7572L20.7654 1.2922C20.9604 1.0972 21.2164 1 21.4724 1ZM20.0374 3.4332L21.4524 4.8482L22.8864 3.4142L21.4724 1.9992C21.4714 1.9992 21.4714 2.0002 21.4714 2.0002L20.0374 3.4332ZM8.4214 17.8782L20.7454 5.5552L19.3304 4.1402L7.0074 16.4652L8.4214 17.8782ZM6.6444 17.5162L6.2754 18.6092L7.3664 18.2382L6.6444 17.5162Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22H0V23H14V22Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.a89bb053c9ac35fe4a14de43636a9aae.svg";
export { ForwardRef as ReactComponent };